// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"85":"8aac56692503b51b","122":"ed63bd91b23c2d4b","208":"f77618a35cc352a9","396":"c1bf473fd6dcdcb8","560":"ebea521b8e07e394","814":"f9ed713d33ab8073","887":"dfd6f1f2bafa651a","888":"602598208d7462b1","932":"4ac178e927de67cc"}[chunkId] + ".js";
};